const IP_ADDRESS1 = "http://10.20.2.19";
const IP_ADDRESS2 = "http://10.20.5.174";
export const CONFIGS ={
  baseUrl: `${IP_ADDRESS1}:3009/admin`,
  vueBaseUrl: `${IP_ADDRESS1}:3000/`,
};